import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/services/api";
import type { UnlockScreenContent } from "@/types";

/** React Query hooks for the admin unlock screen editor (KC-498). A single record. */

export const unlockScreenKeys = {
  all: ["admin", "unlock-screen"] as const,
};

export function useAdminUnlockScreen() {
  return useQuery<UnlockScreenContent>({
    queryKey: unlockScreenKeys.all,
    queryFn: () => api.getAdminUnlockScreen(),
  });
}

export function useUpdateUnlockScreen() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UnlockScreenContent) => api.updateUnlockScreen(data),
    onSuccess: (saved) => queryClient.setQueryData(unlockScreenKeys.all, saved),
  });
}
